[<template>
  <div>
    <el-table
      :data="entries.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
    >
      <el-table-column label="Title" prop="title" sortable></el-table-column>
      <el-table-column label="Category" prop="name" sortable></el-table-column>
      <el-table-column
        label="Position"
        prop="position"
        sortable
      ></el-table-column>
      <el-table-column label="Actions" align="right" width="200%">
        <template slot-scope="props">
          <el-tooltip content="Edit" placement="top">
            <el-button
              type="warning"
              circle
              size="small"
              icon="el-icon-edit"
              @click="openEdit(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Delete" placement="top">
            <el-button
              type="danger"
              circle
              size="small"
              icon="el-icon-close"
              @click="deleteE(props.row.id)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <Dialog />
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="entries.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="entries.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Dialog from './DialogEntry'

export default {
  components: {
    Dialog
  },
  computed: {
    ...mapState('faq', [
      'entries',
      'page',
      'page_size',
      'order_column',
      'order_type'
    ])
  },

  methods: {
    ...mapActions('faq', ['readEntry', 'deleteEntry']),
    ...mapMutations('faq', [
      'setPage',
      'setPageSize',
      'setOrdering',
      'setDialogEntry',
      'setSelectedEntry'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readEntry()
    },
    currentChange(page) {
      this.setPage(page)
      this.readEntry()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readEntry()
    },
    openEdit(entry) {
      this.setDialogEntry(true)
      this.setSelectedEntry(entry)
    },
    deleteE(id) {
      this.$confirm(
        'You will permanently delete this entry. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.deleteEntry(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    }
  },

  created() {
    this.readEntry()
  }
}
</script>
]
